export enum ClientAvailability {
    ENABLED = 0,
    RESTRICTED = 1,
    DISABLED = 2
}
